const POSITION_BOTTOM_RIGHT = 'bottom_right';
const POSITION_BOTTOM_LEFT = 'bottom_left';
const POSITION_TOP_RIGHT = 'top_right';
const POSITION_TOP_LEFT = 'top_left';


const bottomRightPosition = {
    bottom: '2.5em',
    right: '2em',
};

const topRightPosition = {
    top: '2.5em',
    right: '2em',
};

const topLeftPosition = {
    top: '2.5em',
    left: '2em',
};

const bottomLeftPosition = {
    bottom: '2.5em',
    left: '2em',
};

export const TRIGGER_POSITIONS_MAP = {
    [POSITION_BOTTOM_RIGHT]: bottomRightPosition,
    [POSITION_BOTTOM_LEFT]: bottomLeftPosition,
    [POSITION_TOP_RIGHT]: topRightPosition,
    [POSITION_TOP_LEFT]: topLeftPosition,
};